// AUTO-GENERATED from oracle/별을_죽인_자들_원고모음.md — 원고 비트 반영(WS0-2). 재생성: /tmp/gen_manuscript.cjs
export interface ManuscriptScene {
  id: string; name: string; storyline: string; col: string; order: number;
  pov: string; characters: string[]; location: string; summary: string; body: string;
}

export const MANUSCRIPT_SCENES: ManuscriptScene[] = [
  {
    "id": "ms-act1-1",
    "name": "제1막 · 씬 1",
    "storyline": "main",
    "col": "rising",
    "order": 0,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "운송선이 떠나자, 고요해졌다",
    "body": "운송선이 떠나자, 고요해졌다. 그리고 생소한 소리들이 들렸다. 새들과 벌레들의 울음소리, 바람결의 흔들리는 나무들의 춤 소리, 시냇물 소리. 발밑의 사뿐히 가라앉은 흙이 중력을, 여기 있음을 느끼게 했다. 돌아보니 한 여자가 서 있었다. 단정하지 않은 머리에 흙이 묻어 있었다. 나이를 가늠하기 어려웠다 — 늙은 손과 어린 눈.\n\n\"짐은 그게 단가요?\" 여자가 말했다.\n\n\"네.\"\n\n여자는 말 없이 가방을 들었다. 그녀는 아무것도 묻지 않았다. 라디아는 내심 물어 오기를 기다렸다. 그러나 여자는 그저 그녀의 신발을 한 번 내려다보았을 뿐이다.\n\n\"그 신발론 안 돼요.\" 여자가 말했다. \"강을 건너야 하거든.\"\n\n마을은 강 건너에 있었다. 다리는 없었다. 여자는 신발을 벗어 한 손에 들고 망설임 없이 물에 들어섰고, 라디아는 잠시 남아 차가운 물살을 한참 바라보았다. 곧 라디아는 신발을 벗었다. 물은 무릎 위 까지 차올랐다. 돌은 이끼로 미끄러웠고, 그녀의 발은 그 모든 것을 느꼈다. 사원에선 어디를 디뎌도 평평했고 모두 같은 온도였다. 이 강바닥은 한 걸음마다 달랐다. 건너편에서 여자는 기다리지 않고 먼저 발걸음을 옮기고 있었다. 라디아는 종종걸음으로 따라갔다. 차고 축축한 옷이 걸음을 붙잡았다. 이 낯선 불편함들이 조금씩 성가시기 시작했을 때, 라디아는 바로 그 감정을 삼켰다. 공기에서 냄새가 났다. 파이로크라시아의 멸균된 공기에는 없던 것이었다. 젖은 나무껍질, 풀이 썩는 냄새, 그 아래 어렴풋이 비리고도 단 무엇 — 살아 있는 것의 냄새이자 죽어 가는 것의 냄새였다. 라디아는 그것을 가려내려 했지만 가려지지 않았다. 현상을 느끼고, 체험하며 무엇이던 가려내려 했던 습관들은 낯선 곳의 생기있는 냄새와 촉감, 소리들의 하모니에 침식되고 흐려지기 시작했다."
  },
  {
    "id": "ms-act1-2",
    "name": "제1막 · 씬 2",
    "storyline": "main",
    "col": "rising",
    "order": 1,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "마을은 강을 등지고 조금 낮게 앉아 있었다",
    "body": "마을은 강을 등지고 조금 낮게 앉아 있었다. 돌과 진흙으로 지은 집들이 서로 기대듯 모여 있었고, 굴뚝마다 연기가 가늘게 오르고 있었다. 시그마였다면 이 시각의 거리는 대낮처럼 환하고 사람들로 북적거렸을 것이다. 여기서는 해가 나무 너머로 떨어질 참이었고, 아이들은 그 마지막 노을빛을 아끼듯 바깥에서 뛰어놀고 있었다.\n\n한 노인이 문간에서 콩을 까고 있었다. 아이 둘도 흙바닥에 쪼그려 앉아 돕고 있었고, 그 옆에 개가 늘어져 있었다. 여자가 지나가자 몇이 고개를 들어 인사를 건넸다. 그들은 라디아를 호기심의 눈빛으로 바라보았지만 금방 거두었다.\n\n여자가 한 집 앞에 멈췄다. \"여기예요.\" 라디아는 고개를 숙여 비좁은 입구 안으로 들어섰다. 흙바닥에 짚이 깔려 있고 한쪽 귀퉁이엔 나무로 된 침상이 놓여 있었다. \"불은 직접 피워요. 장작은 뒤에 있고.\" 여자는 그 말만 남기고 어두워지는 길로 돌아갔다.\n\n라디아는 장작 앞에 한참을 앉아 있었다. 그녀는 마음이 일어나고 아스라지는 것을 느끼고 조율하는데 능숙했다. 그러나 마른 가지 두 개로 어떻게 불을 일으키는지는, 알지 못했다. 밖에서 아이들의 웃음소리가 들렸다. 집집의 창마다 주황빛이 돋아나고 있었다. 그녀의 방만 어두웠다.\n\n밤이 깊자 추위가 흙바닥을 타고 올라왔다. 라디아는 침상에 누웠다가 다시 일어나, 한쪽에 쌓인 마른 짚을 끌어다 몸을 덮었다. 풀에서 흙냄새가 났다. 옆집 벽 너머로 두런거리는 말소리와 그릇 부딪는 소리가 들렸고, 이내 그것도 잦아들었다. 누군가 기침을 했다. 멀리서 개가 한 번 짖고 그쳤다. 그녀는 그 소리들을 하나하나 새겨 들었다. 라시아를 생각했다. 심안으로 느껴지지는 않았지만 무사 할 것을 알았다. 운명의 고리가 여전히 서로를 강하게 묶고 있었다. 문간에 기척이 났다. 그 여자였다. 뚜껑 덮인 질그릇을 들고 있었다. 여자는 말없이 들어와 화덕 앞에 쪼그려 앉아 뚜껑을 열었다. 안에서 붉은 잉걸이 숨 쉬듯 깜빡였다. 잔가지를 우물 정(井)자로 얹고 그 아래 마른 풀을 밀어 넣은 다음, 잉걸을 묻고 입으로 바람을 불었다. 한 번, 두 번. 연기가 오르고, 작은 불꽃이 풀 끝을 물었다. 여자는 불이 가지로 옮겨붙는 것을 잠시 지켜보다 일어섰다. \"내일은 직접 해 봐요.\" 라디아는 불을 들여다보았다. 불 속에서 많은 게 보였다. 빛은 이미 모든 걸 담고 있었다."
  },
  {
    "id": "ms-act1-3",
    "name": "제1막 · 씬 3",
    "storyline": "main",
    "col": "rising",
    "order": 2,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "라디아는 아침마다 여자를 따라 강으로 갔다",
    "body": "라디아는 아침마다 여자를 따라 강으로 갔다. 여자는 물동이를 어깨에 지는 법을 보여 주었다 — 끈을 이마에 걸고 등으로 받치는. 라디아가 흉내 냈다. 몇 걸음 못 가 물이 출렁여 등을 적셨고, 동이가 기울었다. 길에서 마주친 노인이, 첫 저녁 콩을 까던 그 노인이었는데, 다가와 끈의 매듭을 고쳐 매 주었다. 물은 여전히 무거웠지만 덜 흔들렸다.\n\n저녁이면 그 집 문간에 사람들이 모여 콩을 깠다. 라디아도 그 틈에 끼었다. 처음엔 깍지를 통째로 짓이겨 콩을 으깼다. 옆의 계집아이가, 예닐곱쯤 된 아이가, 깔깔 웃으며 제 손으로 시범을 보였다. 엄지로 깍지의 솔기를 누르면 톡, 하고 벌어졌다. 라디아가 따라 했다. 톡. 콩 세 알이 손바닥에 굴렀다. 아이가 잘했다는 듯 고개를 끄덕였다.\n\n그날 저녁, 그녀의 손바닥에는 콩물이 들어 풋내가 났다. 씻어도 가시지 않았다."
  },
  {
    "id": "ms-act1-4",
    "name": "제1막 · 씬 4",
    "storyline": "main",
    "col": "rising",
    "order": 3,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "테라스타가 한 해의 가장 낮은 자리로 기울 무렵, 곡식이 익었다",
    "body": "테라스타가 한 해의 가장 낮은 자리로 기울 무렵, 곡식이 익었다. 마을은 밭마다 차례로 들어갔다 — 오늘 이 집 밭을 거두면 내일은 저 집 밭이었다. 셈은 없었다. 남자들이 낫을 들고 이삭을 베어 눕히면, 마당에서는 여자들이 그것을 두드려 알곡을 털었다. 라디아도 키를 들었다. 서툰 솜씨에 알곡과 검불이 함께 날렸다.\n\n\"자, 봐 봐.\" 옆에서 누가 손목의 각도를 잡아 주었다. \"바람 부는 쪽으로, 가볍게.\"\n\n검불이 날아가고 알곡이 키 안에 남았다. 라디아가 다시 흉내 내 보았으나 쉽지 않았다.\n\n\"그래서 밥값이나 하겄어?\"\n\n라디아는 멋쩍게 웃었다. 노동이라곤 해 본 적 없는 그녀였다. 이 서툰 순간들이 뜻밖에도 수양처럼 다가왔다. 수양은 정신으로만 하는 것이 아니었다.\n\n고른 알곡이 광장에 수북이 쌓였다. 가장 나이 든 원로가 그것을 집집의 식구 수와 일손을 가늠해 나누었다. 그는 마을 모든 집의 사정을 속속들이 아는 듯했다. 많이 거둔 집도, 적게 거둔 집도, 겨우내 굶지는 않을 만큼.\n\n그 틈을 한 노파가 오갔다. 베인 아이의 손에 약초를 발라 헝겊으로 감아 주고, 멱살까지 잡을 뻔한 두 사내를 한마디로 떼어 놓았다. 일하는 내내 낮게 무언가를 흥얼거렸는데, 가락은 짧고 자꾸 같은 자리로 돌아왔다. 노파가 라디아 앞을 지나다 멈춰, 김이 오르는 것을 손에 쥐여 주었다. 곡식을 쪄 만든 떡이었다. 라디아가 받아 드는 사이 노파는 벌써 저만치 가 있었다.\n\n점심에는 다 같이 둘러앉아 먹었다. 큰 솥의 죽 옆으로 집집이 내온 것들이 늘어섰다 — 절인 나물, 삭힌 콩, 누구네가 잡았다는 마른 물고기. 한 사내가 라디아의 빈약한 그릇을 흘끔 보더니 제 몫의 물고기를 한 점 척 올려 주었다. \"마이 무. 그래야 키질을 하지.\" 둘러앉은 이들이 웃었다.\n\n이튿날 아침, 라디아는 제가 깐 콩 한 줌을 노파의 문간에 두었다. 노파는 그걸 보고도 아무 말 없었다. 다만 그날 저녁, 라디아의 죽 그릇이 유독 걸쭉했다."
  },
  {
    "id": "ms-act1-5",
    "name": "제1막 · 씬 5",
    "storyline": "main",
    "col": "rising",
    "order": 4,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "곡식을 다 거둔 밤, 마을은 강가에 불을 피웠다",
    "body": "곡식을 다 거둔 밤, 마을은 강가에 불을 피웠다. 한 해 중 가장 배부른 밤이었다. 새 곡식으로 빚은 술이 돌았고, 누군가 라디아에게도 한 사발 안겼다.\n\n\"파이로크라시아엔 이런 거 없지야?\"\n\n\"없어요.\"\n\n\"저런, 불쌍해서 어쩌까.\" 사내가 껄껄 웃으며 제 사발을 비웠다.\n\n평소 입지 않던 옷들이 나왔다. 물들인 무늬가 집집이 달랐다. 삭힌 것들과 강에서 잡은 물고기가 멍석에 올랐고, 아이들이 그 사이를 헤집고 다니다 한 번씩 혼이 났다.\n\n불 앞에서 한 노인이 이야기를 풀었고, 아이들이 둘러앉았다. \"옛날 옛적에, 모든 게 한 물에서 났어. 사람도, 저 개도, 저기 저 풀도.\" 노인이 늘어진 개를 가리키자 개가 꼬리를 한 번 쳤다. 아이들이 까르르 웃었다. \"웃지 마라. 다 한 물에서 떠올랐다가, 때 되면 도로 그 물로 드는 거여. 강이 그 물의 한 자락이고.\"\n\n불가 한쪽에선 젊은 사내들이 씨름을 했다. 모래가 일고, 둘러선 이들이 편을 갈라 소리쳤다. 한 사내가 보기 좋게 나가떨어지자 웃음이 터졌다. 이긴 쪽은 우쭐해 처녀들 쪽을 흘끔거렸고, 처녀들은 안 보는 척 다 보고 있었다.\n\n북이 울리자 사람들이 일어나 둥글게 돌았다. 라디아는 가장자리에 서 있었다. 콩을 가르쳐 준 계집아이가 그 손을 잡아끌었다. \"언니두 와요!\" 라디아는 끌려 들어갔다. 걸음이 자꾸 어긋났다. 누가 옆에서 어깨를 잡아 박을 맞춰 주었다. 발이 북을 따라가기 시작하자, 그녀는 어디를 디딜지 더는 헤아리지 않았다.\n\n불티가 별 사이로 올랐다. 누군가 박을 놓쳐 옆 사람과 엉켜 자빠졌고, 또 한바탕 웃음이 터졌다. 라디아도 웃고 있었다."
  },
  {
    "id": "ms-act1-6",
    "name": "제1막 · 씬 6",
    "storyline": "main",
    "col": "rising",
    "order": 5,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "겨울이 깊을 때 한 산모가 산기를 했다",
    "body": "겨울이 깊을 때 한 산모가 산기를 했다. 남자들은 슬그머니 집 밖으로 밀려났다. 안에는 여자들만 남았고, 그 가운데 노파가 있었다.\n\n\"손 있으면 이리 와.\" 노파가 라디아를 불렀다.\n\n라디아는 물을 데우고 천을 받쳤다. 손이 더뎠다. \"거기 말고. 등을. 더 세게 눌러.\" 라디아가 산모의 등을 눌렀다. 곁을 지키던 여자가 산모의 손을 잡고 중얼거렸다. \"아이고, 늦둥이가 어미를 잡네.\"\n\n새벽에 아이가 미끄러져 나왔다. 울음이 터졌다. 피와 물 비린내가 좁은 방을 채웠다 — 멸균된 무엇과는 거리가 멀었다. 노파가 아이를 받아 탯줄을 묶고, 천에 싸 산모의 가슴에 올렸다.\n\n\"누가 돌아왔나 보자.\" 노파가 아이의 얼굴을 들여다보며 낮게 말했다. 라디아도 따라 들여다보았으나, 붉고 쭈글한 얼굴에선 아무도 알아볼 수 없었다.\n\n노파가 라디아를 한 번 보았다. \"손은 더뎌도, 안 도망가는 건 봐줄 만하네.\"\n\n라디아의 손에 피가 묻어 있었다. 콩물처럼, 한참 가시지 않을 것이었다."
  },
  {
    "id": "ms-act1-7",
    "name": "제1막 · 씬 7",
    "storyline": "main",
    "col": "rising",
    "order": 6,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "봄이 더디 오던 해, 노파가 자리에 누웠다",
    "body": "봄이 더디 오던 해, 노파가 자리에 누웠다. 늙음이 한꺼번에 닥친 것뿐이었다. 약은 없었다. 사람들이 번갈아 드나들었다. 누구는 덮을 것을, 누구는 달인 물을 들고 왔다. 노파가 평생 그들에게 해 주던 것이, 이제 거꾸로 그 문턱을 넘어 들어왔다.\n\n라디아가 여러 밤을 맡았다. 그 무렵 마을 사람들은 베인 손도, 앓는 아이도 라디아에게 데려오고 있었다.\n\n라디아는 노파의 손을 잡고, 노파가 가르쳐 준 가락을 낮게 흥얼거렸다. 손가락이 이따금 약하게 그러쥐었다. 그 숨이 어느 결로 잦아들지 라디아는 알 수 있었다. 알아도, 할 수 있는 것은 없었다. 그저 손을 잡고 있었다.\n\n한 밤, 노파가 눈을 떴다. 라디아를 한참 보더니 옅게 웃었다. \"뭘 그리 붙잡고 있어.\" 노파의 눈이 창밖, 강 쪽으로 갔다. \"나 멀리 안 가. 저기 있을 건데.\"\n\n새벽이 오기 전에 숨이 옅어졌다. 그러쥐던 힘이 풀렸다. 라디아는 한참을 더 그 손을 잡고 있었다. 가락은 그녀의 입에 그대로 남아 있었다."
  },
  {
    "id": "ms-act1-8",
    "name": "제1막 · 씬 8",
    "storyline": "main",
    "col": "rising",
    "order": 7,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "노파를 강으로 보내는 날, 눈이 그쳤다",
    "body": "노파를 강으로 보내는 날, 눈이 그쳤다. 여자들이 노파를 씻기고, 한 번도 쓰지 않은 흰 천으로 감쌌다. 우는 이들이 있었다. 그러나 곡(哭)은 아니었다.\n\n누군가 가락을 시작했다. 그 가락이었다 — 곡식을 털 때도, 아이를 받을 때도 노파의 입에 있던. 이끌 사람이 없었다. 라디아가 입을 떼었다. 가락은 이미 그녀의 몸에 있었다. 그녀의 목소리가 앞서 나가자 마을의 목소리가 그 뒤로 포개졌다.\n\n강가에서 가장 나이 든 원로가 물에 대고 말했다. 잘 가라는 말이 아니었다. \"또 봅시다.\" 마치 노파가 듣고 있다는 듯이.\n\n누군가 품의 갓난아이를 추슬렀다. \"이 녀석으로 왔는지도 모르고.\" 옆에서 누가 받았다. \"그라믄 또 키워야겄네.\" 울음 사이로 작은 웃음이 번졌다.\n\n노파는 강으로 들어갔다. 물이 그녀를 받아, 안고, 데려갔다 — 아니, 돌려보냈다. 라디아는 그 물을 알았다. 아침마다 발로 건너고 매일 길어 마시던 물이었다. 이제 그 물속에 노파가 있었다. 노파는 어디로도 가지 않았다. 라디아가 매일 건너는 강이 되었을 뿐이다."
  },
  {
    "id": "ms-act1-9",
    "name": "제1막 · 씬 9",
    "storyline": "main",
    "col": "rising",
    "order": 8,
    "pov": "radia",
    "characters": [
      "radia"
    ],
    "location": "arcadia",
    "summary": "계절이 한 번 더 바뀌었다",
    "body": "계절이 한 번 더 바뀌었다. 강물이 줄어 바닥의 돌이 드러났다.\n\n라디아는 화덕 앞에서 부싯돌을 쳤다. 한 번, 두 번. 불씨가 마른 풀 끝에 붙었다. 누구의 불도 아닌, 그녀의 불이었다. 그녀는 잉걸 한 덩이를 질그릇에 옮겨 담았다.\n\n신을 벗어 한 손에 들고 강에 들어섰다. 발이 돌의 자리를 먼저 알았다. 그 물은 노파였다. 라디아는 매일 노파를 건넜다.\n\n건너편에 새로 온 사람이 서 있었다. 운송선이 막 떠난 자리에, 가방 하나를 든 채, 신발이 젖는 줄도 모르고 물살을 바라보며. 라디아는 그 앞에 가, 잉걸이 담긴 그릇을 내밀었다. 여자가 받아 들고 어쩔 줄 몰라 했다.\n\n\"불은 직접 피우는 거예요.\" 라디아가 말했다. \"오늘은 그걸로 하고.\"\n\n여자가 무어라 물으려 했다. 신발은요, 짐은요, 마을은 머냐고. 라디아는 옛날의 제 모습을 보는 듯해 조금 웃었다. 그러고는 여자의 신발을 한 번 내려다보았다.\n\n\"그 신발론 강 못 건너요.\"\n\n등 뒤에서 누가 그녀의 이름을 불렀다. 마을 쪽이었다. 라디아는 돌아섰다. 사원에서 그녀는 우주의 가장 깊은 결에 귀 기울이는 법을 알았다. 여기서는 불을 피우고, 강을 건너고, 돌아오는 이를 맞는 법을 알았다. 어느 쪽이 더 깊은지, 그녀는 더 묻지 않았다. 아침 해가 등을 데우고 있었다.\n\n---"
  },
  {
    "id": "ms-frag-1",
    "name": "화물",
    "storyline": "sisters",
    "col": "rising",
    "order": 100,
    "pov": "rasia",
    "characters": [
      "rasia"
    ],
    "location": "loc-phantom",
    "summary": "> 라시아의 밀수 시절",
    "body": "> 라시아의 밀수 시절. 원고 본편(스콘스 합류)보다 이전. 비연속 스케치.\n\n거래는 늘 가게 마감 즈음이었다. 몬테카를로의 사이키 조명이 흐려지고 술 취한 손님들을 마담이 하나씩 달래거나, (누군가의 도움을 빌려) 처리하는 궂은 일을 할 때쯤, 라시아는 뒷문으로 나가 지하 하역장으로 내려갔다. 작업등 하나가 콘크리트 벽에 누런 빛을 발랐다. 곰팡이와 기름, 어렴풋한 소독약 냄새들이 섞여 역한 냄새가 코를 찔렀다. 그때 맞은편에서 운반차의 화물칸이 끼익 열렸다.\n\n\"여섯이라매.\" 라시아가 담배 연기를 뱉으며 말했다.\n\n\"다섯이야. 하나는 오는 길에 뒤졌어.\" 제롬이 어깨를 으쓱했다. \"알잖아. 타르가 어떤 곳인지.\"\n\n라시아는 굳이 화물칸을 들여다보지 않았다. \"결제했어.\" 라시아가 모바일 단말의 홍채인식을 마치고 말했다.\n\n칸 안에서 중얼거리는 소리가 들렸다. 앳된 목소리였다. 무슨 말인지 알아듣지 못했고, 라시아는 알아들으려 하지 않았다. \"다음은, 보름 뒤?\"\n\n\"일단은. 근데 모르지.\" 제롬이 라시아의 몇 모금 남지 않은 담배를 빼앗아 물었다. \"문제 있으면 말해줄게.\"\n\n라시아는 잠시 제롬을 흘기더니 칸 안의 인원들에게 소리쳤다. \"나와. 대가리 숙이고, 재빠르게 나를 따라와. 차는 세 대로 나눠서 탄다.\" 운반차에서 사람들이 내리고, 라시아는 손짓으로 그들을 이끌며 골목 어귀로 재빠르게 이동했다."
  },
  {
    "id": "ms-frag-2",
    "name": "빛",
    "storyline": "forgium",
    "col": "rising",
    "order": 101,
    "pov": "ian",
    "characters": [
      "ian"
    ],
    "location": "loc-sigma",
    "summary": "> 본편 진행 중 — 이안의 포지움 연구기",
    "body": "> 본편 진행 중 — 이안의 포지움 연구기. 콘티넨탈 개발 이전/초기.\n\n시그마에는 밤이 없었다. 에테르 등이 거리를 한낮처럼 밝혔고, 유리와 강철의 탑들은 제 빛을 되쏘아 하늘의 별을 지웠다. 이안 로크의 작업실은 그 탑들 중 하나의 꼭대기에 있었다.\n\n새벽 세 시. 그러나 시각은 숫자일 뿐이었다. 이안은 작업대 위로 몸을 숙인 채 머리카락 한 올 두께의 회로를 들여다보고 있었다. 손끝이 미세하게 떨릴 때마다 확대경 속 풍경이 함께 흔들렸다. 며칠째 같은 자세였다.\n\n조명이 한 단계 낮아졌다.\n\n이안이 고개를 들었다. 그녀가 막 스위치에서 손을 떼고 있었다. 사람의 모양을 했으나, 사람은 아니었다.\n\n\"눈을 비비셨어요.\" 그녀가 말했다. \"빛이 너무 센 것 같아서요.\"\n\n이안은 잠시 그녀를 바라보았다. 필요한 것보다 조금 긴 시간이었다.\n\n\"고마워.\" 그는 다시 확대경 위로 몸을 숙였다. 어두워진 빛 아래, 회로의 가는 선들이 한결 또렷했다."
  },
  {
    "id": "ms-frag-3",
    "name": "불침번",
    "storyline": "tar",
    "col": "rising",
    "order": 102,
    "pov": "kylis",
    "characters": [
      "kylis"
    ],
    "location": "loc-sconce",
    "summary": "> 본편 — 스콘스 진영",
    "body": "> 본편 — 스콘스 진영. 라시아 합류 전후 무렵.\n\n테라스타가 뜨기 전에도 타르는 식지 않았다. 밤새 달궈진 모래가 열을 머금었고, 공기에선 마른 먼지와 식은 모닥불 냄새가 났다.\n\n카일리스는 모두가 잠든 시각에 깨어 있었다. 막사 사이를 소리 없이 걸으며 초소를 하나씩 지났다. 첫 번째 보초는 깨어 있었다. 두 번째도. 세 번째 초소의 사내는 소총을 무릎에 걸친 채 고개를 떨구고 있었다.\n\n그녀는 그를 깨우지 않았다. 대신 그의 손에서 소총을 조용히 빼내어, 그 자리에 서서 어둠 너머를 응시했다.\n\n사내가 눈을 떴다. 숨을 들이켜는 소리. 무어라 말하려는 기척. 카일리스는 돌아보지 않은 채 그에게 총을 내밀었다. 그러고는 다음 초소로 걸어갔다.\n\n동쪽 암벽 위로 테라스타의 첫 빛이 번졌다. 카일리스가 지나간 자리마다, 보초들은 조금 더 꼿꼿이 섰다.\n\n---\n\n*— 원고 모음 끝. 세계관 = 바이블 v3.1 / 아르카디아 캐논 · 문체·구조 = 작문 프레임워크 / 제1막 비트시트. —*"
  }
];
